import type { RoomTemplate } from "../types/C1_ModelTypes";
import { RoomType } from "../types/C1_RoomTypes";

export type RoomPaletteChapterId = "living" | "functional" | "outside" | "other";

const chapterTypes = {
  living: [RoomType.Living, RoomType.Dining, RoomType.Kitchen,
    RoomType.Office, RoomType.Bathroom, RoomType.GuestToilet, RoomType.Bedroom,
    RoomType.Child, RoomType.Hallway, RoomType.Staircase, RoomType.Hobby, RoomType.Other],
  functional: [RoomType.Storage, RoomType.HeatingRoom, RoomType.Utility,
    RoomType.UtilityConnectionRoom, RoomType.Laundry],
  outside: [RoomType.Garden, RoomType.Entrance, RoomType.Terrace, RoomType.Balcony,
    RoomType.PenthousePerimeter, RoomType.RoofTerrace, RoomType.GarageDriveway,
    RoomType.Garage, RoomType.DetachedGarage, RoomType.Carport, RoomType.Roof],
} satisfies Record<Exclude<RoomPaletteChapterId, "other">, RoomType[]>;

export function isLivingRoomType(type: RoomType): boolean {
  return (chapterTypes.living as readonly RoomType[]).includes(type);
}

/** Each template appears in one chapter, independent of the current floor. */
export function roomPaletteChapters(templates: RoomTemplate[], language: string): Record<RoomPaletteChapterId, RoomTemplate[]> {
  const assignedTypes = new Set<RoomType>(Object.values(chapterTypes).flat());
  const byTypes = (types: readonly RoomType[]) => types.flatMap(type => templates.filter(template => template.type === type));
  return {
    living: byTypes(chapterTypes.living),
    functional: byTypes(chapterTypes.functional),
    outside: byTypes(chapterTypes.outside),
    other: templates.filter(template => !assignedTypes.has(template.type))
      .sort((left, right) => left.description[language].localeCompare(right.description[language], language)),
  };
}
